<template>
  <MobileActionsSheet
    :open="appStore.showMobileRecordSheet"
    label="Record or import"
    @close="close"
  >
    <button
      v-if="recordingEnabled"
      type="button"
      class="mobile-sheet__row"
      @click="startRecording"
    >
      <span class="mobile-sheet__icon mobile-sheet__icon--record">
        <IconMic />
      </span>
      <span class="mobile-sheet__text">
        <strong>Start recording</strong>
        <small>Live transcription while you talk</small>
      </span>
    </button>
    <button type="button" class="mobile-sheet__row" @click="importFile">
      <span class="mobile-sheet__icon mobile-sheet__icon--import">
        <IconImport />
      </span>
      <span class="mobile-sheet__text">
        <strong>Import a file</strong>
        <small>Audio or video from this device</small>
      </span>
    </button>
  </MobileActionsSheet>
</template>

<script>
import MobileActionsSheet from "./MobileActionsSheet.vue";
import IconMic from "./icons/IconMic.vue";
import IconImport from "./icons/IconImport.vue";
import { useAppStore } from "@/stores/app-store";
import { mapStores } from "pinia";
import { analytics, isRecordingEnabled } from "@/services/analytics.service";

export default {
  name: "MobileRecordSheet",
  components: { MobileActionsSheet, IconMic, IconImport },
  computed: {
    ...mapStores(useAppStore),
    recordingEnabled() {
      return isRecordingEnabled();
    },
  },
  watch: {
    "appStore.showMobileRecordSheet"(open) {
      if (open) analytics.mobileRecordSheetOpened();
    },
  },
  methods: {
    close() {
      this.appStore.showMobileRecordSheet = false;
    },
    startRecording() {
      this.close();
      this.appStore.showRecordingPopup = true;
    },
    importFile() {
      this.close();
      this.appStore.openImportPopup();
    },
  },
};
</script>
